import React from "react";
import { cn } from "../../utils/cn";

type AuthPageProps = {
  title: React.ReactNode;
  description?: React.ReactNode;
  /** "narrow" suits single-column forms; "wide" suits the multi-column ones. */
  width?: "narrow" | "wide";
  children: React.ReactNode;
  footer?: React.ReactNode;
};

const AuthPage = ({
  title,
  description,
  width = "narrow",
  children,
  footer,
}: AuthPageProps) => {
  return (
    <div
      className={cn(
        "mx-auto w-full",
        width === "narrow" ? "max-w-[440px]" : "max-w-full"
      )}
    >
      <h1 className="font-sora text-[24px] font-bold text-foreground">
        {title}
      </h1>
      {description && (
        <p className="mt-2 text-sm font-medium text-muted-foreground">
          {description}
        </p>
      )}

      <div className="mt-8">{children}</div>

      {footer && <div className="mt-6 text-center text-sm">{footer}</div>}
    </div>
  );
};

export default AuthPage;
